import {
    REQUEST_FETCH_SPACE_LOGS,
    FETCH_SPACE_LOGS_SUCCESS,
    FETCH_SPACE_LOGS_ERROR,
  } from '../../../actions/reservations/space/fetchSpacesLogs';
    
  const initialState = {
    logs: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  };
  
  const spaceLogReducer = (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_FETCH_SPACE_LOGS: {
        return {
          ...state,
          logs: [],
          processing: false,
          fetching: true,
          message: "",
          error: "",
        };
      }
      case FETCH_SPACE_LOGS_SUCCESS: {
        return {
          ...state,
          logs: action.logs,
          processing: false,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case FETCH_SPACE_LOGS_ERROR: {
        return {
          ...state,
          logs: [],
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
     
      default: {
        return state;
      }
    }
  };
  
  export default spaceLogReducer;
  